
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/panels/commonControls/PageHierarchyTitleWithChildPages/PageHierarchyTitleWithChildPages.scss.css.virtualfile';
        module.exports = {"root":"_root_tbhyh_1"};